<ul
  #element
  class='AuthenticatedHeader--menu list-unstyled mb-0 mx-auto d-flex flex-row h-100'>
  <li
    *ngFor='let item of menuItems'
    class='AuthenticatedHeader--menu--item'>
    <a
      *ngIf='item.route'
      [routerLink]='[item.route]'
      class='AuthenticatedHeader--menu--item--link'>
      <app-svg-renderer
        *ngIf='item.icon'
        [svg]='item.icon'
        class='AuthenticatedHeader--menu--item--link--icon'></app-svg-renderer>
      <div *ngIf='item.asHTML' [innerHtml]='item.label' class='AuthenticatedHeader--menu--item--label'></div>
      <span *ngIf='!item.asHTML' class='AuthenticatedHeader--menu--item--label'>{{ item.label }}</span>
    </a>
    <a
      (click)='item.onClick()'
      *ngIf='item.onClick'
      class='AuthenticatedHeader--menu--item--link'>
      <app-svg-renderer
        *ngIf='item.icon'
        [svg]='item.icon'
        class='AuthenticatedHeader--menu--item--link--icon'></app-svg-renderer>
      <div *ngIf='item.asHTML' [innerHtml]='item.label' class='AuthenticatedHeader--menu--item--label'></div>
      <span *ngIf='!item.asHTML' class='AuthenticatedHeader--menu--item--label'>{{ item.label }}</span>
    </a>
    <a
      *ngIf='!item.route && !item.onClick'
      class='AuthenticatedHeader--menu--item--link'>
      <app-svg-renderer
        *ngIf='item.icon'
        [svg]='item.icon'
        class='AuthenticatedHeader--menu--item--link--icon'></app-svg-renderer>
      <span class='AuthenticatedHeader--menu--item--label'>{{ item.label }}</span>
    </a>
    <span class='AuthenticatedHeader--menu--item--bottom'></span>
    <ul
      *ngIf='item.children && item.children.length > 0'
      class='AuthenticatedHeader--menu--item--inner'>
      <ng-template #subItemsTop let-innerItem='innerItem'>
        <div class='d-flex w-100'>
          <app-svg-renderer
            *ngIf='innerItem.icon'
            [svg]='innerItem.icon'
            class='AuthenticatedHeader--menu--item--inner--item--icon'></app-svg-renderer>
          <a
            *ngIf='innerItem.route && innerItem.route.indexOf("http") == -1'
            [ngClass]="{
                    'no-sub-menu':
                      !innerItem.children || !innerItem.children.length
                  }"
            [routerLink]='[innerItem.route]'
            class='AuthenticatedHeader--menu--item--inner--item--link'>
                  <span
                    *ngIf='innerItem.asHTML'
                    [innerHtml]='innerItem.label'></span>
            <span *ngIf='!innerItem.asHTML'>{{ innerItem.label }}</span>
          </a>
          <a
            *ngIf='innerItem.route && innerItem.route.indexOf("http") > -1'
            [href]='[innerItem.route]'
            [ngClass]="{
                    'no-sub-menu':
                      !innerItem.children || !innerItem.children.length
                  }"
            class='AuthenticatedHeader--menu--item--inner--item--link'
            target='_blank'>
                  <span
                    *ngIf='innerItem.asHTML'
                    [innerHtml]='innerItem.label'></span>
            <span *ngIf='!innerItem.asHTML'>{{ innerItem.label }}</span>
          </a>
          <a
            *ngIf='innerItem.onClick'
            [ngClass]="{
                    'no-sub-menu':
                      !innerItem.children || !innerItem.children.length
                  }"
            [routerLink]=''
            class='AuthenticatedHeader--menu--item--inner--item--link'>
                  <span
                    *ngIf='innerItem.asHTML'
                    [innerHtml]='innerItem.label'></span>
            <span *ngIf='!innerItem.asHTML'>{{ innerItem.label }}</span>
          </a>
          <a
            *ngIf='!innerItem.route && !innerItem.onClick'
            [ngClass]="{
                    'no-sub-menu':
                      !innerItem.children || !innerItem.children.length
                  }"
            class='AuthenticatedHeader--menu--item--inner--item--link'>
            <span>{{ innerItem.label }}</span>
          </a>
        </div>
        <span
          (click)='innerItem.onClick()'
          *ngIf='innerItem.hasToggle'
          class='AuthenticatedHeader--controller'
        >Turn {{ innerItem.toggleValue ? 'Off' : 'On' }}</span
        >
        <ul
          *ngIf='innerItem.children && innerItem.children.length > 0'
          class='AuthenticatedHeader--menu--item--inner--item--inner'>
          <ng-template #subItems let-subItem='subItem'>
            <div>
              <app-svg-renderer
                *ngIf='subItem.icon'
                [svg]='subItem.icon'
                class='AuthenticatedHeader--menu--item--inner--item--inner--item--icon'></app-svg-renderer>
              <a
                *ngIf='subItem.route'
                [routerLink]='[subItem.route]'
                class='no-sub-menu'>
                      <span
                        *ngIf='subItem.asHTML'
                        [innerHtml]='subItem.label'></span>
                <span *ngIf='!subItem.asHTML'>{{ subItem.label }}</span>
              </a>
              <a
                *ngIf='subItem.onClick'
                [routerLink]=''
                class='no-sub-menu'>
                      <span
                        *ngIf='subItem.asHTML'
                        [innerHtml]='subItem.label'></span>
                <span *ngIf='!subItem.asHTML'>{{ subItem.label }}</span>
              </a>
            </div>
            <span
              (click)='subItem.onClick()'
              *ngIf='subItem.hasToggle'
              class='AuthenticatedHeader--controller'
            >Turn {{ subItem.toggleValue ? 'Off' : 'On' }}</span
            >
          </ng-template>
          <ng-container
            *ngFor='let subItem of innerItem.children'>
            <li
              *ngIf='subItem.route'
              [routerLink]='[subItem.route]'
              class='AuthenticatedHeader--menu--item--inner--item--inner--item'>
              <ng-container
                [ngTemplateOutletContext]='{
                  subItem: subItem
                }'
                [ngTemplateOutlet]='subItems'></ng-container>
            </li>
            <li
              (click)='subItem.onClick()'
              *ngIf='subItem.onClick'
              [routerLink]=''
              class='AuthenticatedHeader--menu--item--inner--item--inner--item'>
              <ng-container
                [ngTemplateOutletContext]='{
                  subItem: subItem
                }'
                [ngTemplateOutlet]='subItems'></ng-container>
            </li>
          </ng-container>
        </ul>
      </ng-template>
      <ng-container *ngFor='let innerItem of item.children'>
        <li
          *ngIf='innerItem.route && innerItem.route.indexOf("http") == -1'
          [routerLink]='[innerItem.route]'
          class='AuthenticatedHeader--menu--item--inner--item'>
          <ng-container
            [ngTemplateOutletContext]='{
                  innerItem: innerItem
                }'
            [ngTemplateOutlet]='subItemsTop'></ng-container>
        </li>
        <li
          (click)='innerItem.onClick()'
          *ngIf='innerItem.onClick'
          class='AuthenticatedHeader--menu--item--inner--item'>
          <ng-container
            [ngTemplateOutletContext]='{
                  innerItem: innerItem
                }'
            [ngTemplateOutlet]='subItemsTop'></ng-container>
        </li>
        <li
          *ngIf='(!innerItem.route && !innerItem.onClick) || (innerItem.route && innerItem.route.indexOf("http") > -1)'
          class='AuthenticatedHeader--menu--item--inner--item'>
          <ng-container
            [ngTemplateOutletContext]='{
                  innerItem: innerItem
                }'
            [ngTemplateOutlet]='subItemsTop'></ng-container>
        </li>
      </ng-container>

    </ul>
  </li>
</ul>
